export default "__VITE_PUBLIC_ASSET__3cfbc410__"